module.exports = __webpack_public_path__ + "img/015-cake.986d515b.png";